export const FormValidation = {
    email: {
        required: 'Email address cannot be empty.',
        pattern: {
            value: /^[\w\u00E4\u00F6\u00FC\u00C4\u00D6\u00DC\u00DF'\.-]+@[\w.-]+\.[\w]{2,4}$/,
            message: 'Invalid email address format. Allowed format: name@company.domain',
        },
        maxlength: {
            value: 100,
            message: 'Email address cannot be more than 100 characters.',
        },
    },
    loginPassword: {
        required: 'Password cannot be empty.',
    },
    registerPassword: {
        required: 'Password cannot be empty.',
        minlength: {
            value: 8,
            message: 'Password cannot be less than 8 character.',
        },
        maxlength: {
            value: 24,
            message: 'Password cannot be more than 24 characters.',
        },
        pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*(),.+;:?\/]).{0,}$/,
            message:
                "Password must contain one upper case letter, one digit and one special character out of '~!@#$%^&*(),.+;:?/'",
        },
    },
    confirmPassword: {
        required: 'Confirm password cannot be empty.',
    },
    first_name: {
        required: 'First name cannot be empty.',
        maxlength: {
            value: 50,
            message: 'First name cannot be more than 50 characters.',
        },
        pattern: {
            value: /^[a-zA-ZÀ-ÿ0-9. ' -]{1,50}$/,
            message:
                "System supports following for First Name: [A-Z] [a-z] [À-ÿ] [0-9] and special characters: . - '",
        },
    },
    last_name: {
        required: 'Last name cannot be empty.',
        maxlength: {
            value: 50,
            message: 'Last name cannot be more than 50 characters.',
        },
        pattern: {
            value: /^[a-zA-ZÀ-ÿ0-9. ' -]{1,50}$/,
            message:
                "System supports following for Last Name: [A-Z] [a-z] [À-ÿ] [0-9] and special characters: . - '",
        },
    },
    confirm_password: {
        rule: {
            required: true,
            trimEqualTo: '#password_input',
            HasName: true,
        },
        message: {
            required: 'Confirm password cannot be empty.',
            trimEqualTo: 'Your password and confirmation password do not match.',
            HasName: 'Password cannot contain the first name or the last name.',
        },
    },
    fullname: {
        rule: {
            fullnamecheck: true,
        },
        message: {
            required: 'Field connot be empty',
            fullnamecheck:
                'Fullname connot be more than 80 characters or cannot be smaller than 3 character',
        },
    },
    primary_role: {
        required: 'You must select a role.',
    },
    ContactUsfullName: {
        rule: {
            required: true,
            minlength: 3,
            maxlength: 80,
            fullnamecheck: true,
            contactus_message_rule: true,
        },
        message: {
            fullnamecheck:
                'Please make sure the full name does not contain special characters and numbers.',
            contactus_message_rule: 'Name should not contain leading or trailing spaces',
            required: 'Please fill in the full name field.',
            minlength: 'Full name length should be at least 3 characters.',
            maxlength: 'Full name length should not be greater than 80 characters.',
        },
    },
    contactus_message: {
        rule: {
            required: true,
            minlength: 3,
            maxlength: 255,
            contactus_message_rule: true,
        },
        message: {
            required: 'Please fill in the description field.',
            contactus_message_rule: 'Message should not contain leading or trailing spaces',
        },
    },
}
